<template>
  <div id="common">
    <div class="page" size="A4" v-for="page in pages" :key="'page' + page">
      <div class="watermark" v-if="sale.status == 'draft'">
        RASCUNHO
      </div>
      <div
        class="watermark"
        v-if="sale.status == 'order' && sale.operation_id == 2"
      >
        NÃO RECEBIDA
      </div>
      <v-row class="pt-2">
        <v-col cols="1">
          <v-avatar size="30">
            <img
              src="https://casasdastintas.com.br/_nuxt/icons/icon_512x512.9bcf77.png"
            />
          </v-avatar>
        </v-col>
        <v-col style="line-height: 10pt">
          <b style="font-size: 10px">Rede Casas das Tintas</b>
          <template v-if="hasAddress">
            <div>
              {{ sale.company.main_address.address }}
              {{ sale.company.main_address.number }},
              {{ sale.company.main_address.district }}

              {{ sale.company.main_address.city }} -
              {{ sale.company.main_address.state }},
              {{ $format.cep(sale.company.main_address.postal_code) }},
            </div>
          </template>
          <div v-if="hasPhones" class="d-flex flex-row">
            <span class="mr-2">Tel:</span>
            <div v-for="(phone, index) in phones" :key="index">
              {{ phone }}

              <span class="mr-1" v-if="phones.length > index + 1">,</span>
            </div>
          </div>
        </v-col>

        <v-col cols="3" style="font-size: 10px; line-height: 15pt">
          <div class="text-center">
            <span v-if="sale.operation_id == 1">
              {{ status[sale.status] }}
            </span>
            <span v-if="sale.operation_id == 2">
              {{ sale.operation.description }}
            </span>
          </div>

          <div class="text-center">N° {{ sale.number }}</div>
          <div class="text-right">
            {{ `${page}/${pages} ` }}
          </div>
        </v-col>
      </v-row>
      <div>
        <hr class="mt-2 mb-4" />
      </div>
      <v-row class="d-flex justify-space-between align-center mb-2">
        <v-col cols="7">
          <b>Dados Do Cliente</b>
          <div v-if="hasCustomer">
            <span>
              <b>Nome:</b> {{ sale.customer.code }} -{{ sale.customer.name }}
            </span>
            <br />
            <span v-if="docNumber">
              <b>{{ docLabel }} </b>{{ $format.hide(docNumber, { end: 6 }) }}
            </span>

            <div class="d-flex">
              <span class="mr-2" v-if="sale.customer.phone_wa">
                WhatsApp:{{ sale.customer.phone_wa }}
              </span>
              <app-show-phones
                class="d-flex"
                style="justify-content: space-between"
                :phones="sale.customer.phones"
              />
            </div>
            <span>
              <b>Endereço: </b>
              {{ sale.customer.main_address.address }},
              {{ sale.customer.main_address.number }},
              {{ sale.customer.main_address.district }},
              {{ sale.customer.main_address.city }}-
              {{ sale.customer.main_address.state }},
              {{ $format.cep(sale.customer.main_address.postal_code) }}
              <span v-if="sale.customer.main_address.complement">
                <br />
                {{ sale.customer.main_address.complement }}
              </span>
            </span>
          </div>
          <div v-else>
            <span> <b>Nome: </b> Consumidor Final </span>
          </div>
        </v-col>

        <v-col cols="4">
          <div>
            <b>Vendedor: </b> {{ sale.salesman.code }} -{{
              sale.salesman.short_name
            }}
            <br />
            <b>Data de emissão: </b>{{ $format.dateTimeBr(date) }}
            <br />
          </div>
        </v-col>
      </v-row>

      <v-data-table
        :page="page"
        :headers="dynamicHeaders"
        :mobile-breakpoint="0"
        :items="getItems(page)"
        :items-per-page="-1"
        hide-default-footer
        disable-sort
        dense
      >
        <template v-slot:[`item.product`]="{ item }">
          <span v-if="item.product">
            {{ item.product_company.company.code }} -

            {{ item.product.code }} - {{ item.product.name }}
          </span>
        </template>

        <template v-slot:[`item.quantity`]="{ item }">
          <span v-if="item.product">
            {{ $format.decimal(item.quantity) }}
            {{ item.product_variant.unity.symbol }}</span
          >
        </template>
        <template v-slot:[`item.withdraw_quantity`]="{ item }">
          <span v-if="item.product">
            {{ $format.decimal(item.withdraw_quantity) }}
            {{ item.product_variant.unity.symbol }}</span
          >
        </template>

        <template v-slot:[`item.price`]="{ item }">
          <span v-if="item.product"> {{ $format.decimal(item.price) }}</span>
        </template>
        <template v-slot:[`item.net_price`]="{ item }">
          <span v-if="item.product"> {{ getNetPrice(item) }}</span>
        </template>

        <template v-slot:[`item.net_total`]="{ item }">
          <span v-if="item.product">
            {{ $format.decimal(item.net_total) }}</span
          >
        </template>
      </v-data-table>
      <span v-if="sale.delivery_type == 'delivery'" class="mb-1 text-justify">
        O prazo de entrega padrão é de até 30 dias a partir da data da compra.
        Caso exceda esse prazo a entrega dependerá da disponibilidade do estoque
        e programação logística,

        <u>
          As entregas de cimento serão realizadas exclusivamente no térreo.
        </u>
      </span>
      <v-row style="word-break: break-word" v-if="page == 1">
        <v-col>
          <br />
          <span v-if="sale.has_negotiation">
            Proposta: {{ $format.moneyBr(sale.negotiation_value) }} -
            {{ sale.negotiation_comments }}
          </span>
          <span v-if="sale.notes">Observação: {{ sale.notes }}</span>
        </v-col>
      </v-row>

      <template v-if="page == pages">
        <v-row class="mt-1">
          <v-col>
            <span v-for="(bill, index) in sale.sale_bills" :key="index">
              <span v-if="bill.payment_method == 'bill' && hasPaymentTerms">
                {{ getPaymentTermDescription(bill).payment_term.name }}
              </span>
              <PaymentMethodSpan v-else :paymentMethod="bill.payment_method" />

              <span v-if="bill.installments"> {{ bill.installments }}x </span>
              <span
                :key="'index' + index"
                v-if="index < sale.sale_bills.length - 1"
              >
                |
              </span>
            </span>
          </v-col>
          <v-col class="d-flex flex-column text-right">
            <span>
              <b class="mr-1">Sub-Total: </b>
              {{ $format.moneyBr(sale.product_total) }}
            </span>

            <span>
              <b class="mr-1">Desconto:</b>
              {{ $format.moneyBr(sale.discount) }}
            </span>

            <span>
              <b class="mr-1"> Total:</b>
              {{ $format.moneyBr(sale.net_total) }}
            </span>
          </v-col>
        </v-row>

        <template v-if="sale.status == 'proposal'">
          *** Orçamento de venda (válido por 7 dias) ***
        </template>
      </template>
      <template v-if="showSignature(page)">
        <v-row class="d-flex justify-center text-center mt-15">
          <v-col cols="6">
            <v-divider style="border: 0.1px solid black; font-weight: bold" />

            Assinatura

            <div class="align-baseline mt-2">
              <b>Não é documento fiscal</b>
            </div>
          </v-col>
        </v-row>
      </template>
    </div>
  </div>
</template>

<script>
import AppShowPhones from "@/components/app/sections/AppShowPhones.vue";
import PaymentMethodSpan from "@/components/payment-terms/ui/PaymentMethodSpan.vue";
export default {
  components: { AppShowPhones, PaymentMethodSpan },
  props: {
    sale: {},
    hasAddress: {},
    hasPhones: {},
    phones: {},
  },
  data() {
    return {
      itensPerPage: 10,

      headers: [
        { text: "Produto", value: "product" },
        {
          text: "Quantidade",
          value: "quantity",
          align: "center",
          width: "5%",
        },
        {
          text: "P. Bruto",
          value: "price",
          align: "center",
          width: "10%",
        },
        {
          text: "P. Liquido",
          value: "net_price",
          align: "center",
          width: "10%",
        },
        { text: "Total", value: "net_total", align: "center", width: "10%" },
      ],

      status: {
        sale: "Venda",
        proposal: "Orçamento",
        draft: "Rascunho",
      },
    };
  },

  computed: {
    dynamicHeaders() {
      const headers = [...this.headers];
      if (this.hasWithdrawQuantity) {
        headers.splice(2, 0, {
          text: "Retirada",
          value: "withdraw_quantity",
          align: "center",
          cellClass: "print-highlight",
          width: "5%",
        });
      }
      return headers;
    },
    hasCustomer() {
      return this.sale.customer_id;
    },
    personType() {
      return this.sale.customer.person_type;
    },
    docLabel() {
      return this.personType == "juridica" ? "CNPJ:" : "CPF:";
    },
    docNumber() {
      return this.personType == "juridica"
        ? this.$format.cnpj(this.sale.customer.cnpj)
        : this.$format.cpf(this.sale.customer.cpf);
    },

    pages() {
      return Math.ceil(this.itensCount / this.itensPerPage);
    },

    sale_products() {
      return this.sale.sale_products;
    },
    itensCount() {
      if (this.sale_products) {
        return this.sale_products.length;
      }
      return 1;
    },
    hasPaymentTerms() {
      return this.sale.sale_payment_terms.length > 0;
    },
    hasWithdrawQuantity() {
      return (
        this.sale_products &&
        this.sale_products.some((product) => product.withdraw_quantity > 0)
      );
    },
    date() {
      var statues = {
        canceled: "canceled_at",
        sale: "sold_at",
        order: "ordered_at",
        proposal: "proposed_at",
        draft: "drafted_at",
      };
      return this.sale[statues[this.sale.status]] ?? this.sale.saved_at;
    },
  },
  methods: {
    hasItemOnIndex(page, item) {
      return this.getIndex(page, item) < this.itensCount;
    },
    getNetPrice(product) {
      let netPrice =
        product.price - (product.price * product.discount_percent) / 100;

      return this.$format.decimal(netPrice);
    },

    getItems(page) {
      let items = this.sale_products.slice(
        (page - 1) * this.itensPerPage,
        page * this.itensPerPage
      );
      if (items.length < this.itensPerPage) {
        for (let i = items.length; i < this.itensPerPage; i++) {
          items.push({});
        }
      }
      return items;
    },
    getPaymentTermDescription(bill) {
      return this.sale.sale_payment_terms.find((item) => {
        return item.payment_term.payment_method == bill.payment_method;
      });
    },

    // method para definir  se o campo de assinatura deve ser exibido
    showSignature(page) {
      return this.sale.status == "sale";
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/style/prints/CommonPrinting.scss";

.print-highlight {
  background-color: #e9e9e9e9 !important;
  color: black !important;
  padding: 0 4px !important;

  @media print {
    background-color: #e9e9e9e9 !important;
    -webkit-print-color-adjust: exact !important;
    color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
}
</style>
